export default "__VITE_ASSET__CMwbiU9O__"